<template>
	<div class="card-body">
		<div class="row">
			<div class="col-12 col-md-10">
				<div class="form-group">
					<label>Name</label>
					<input type="text" class="form-control" v-model.lazy="name" />
				</div>
			</div>
			<div class="col-12 col-md-2">
				<div class="form-group">
					<label>Level</label>
					<input type="number" class="form-control" v-model.number="cLevel" />
				</div>
			</div>
		</div>
		<hr />
		<div class="row">
			<div class="col-12 col-sm-3">
				<label>Basics</label>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Size</span>
					</div>
					<input class="form-control" v-model="size">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Type</span>
					</div>
					<input class="form-control" v-model="type">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Senses</span>
					</div>
					<input class="form-control" v-model="senses">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Good Save</span>
					</div>
					<select class="form-control" v-model="save">
						<option>Fortitude</option>
						<option>Reflex</option>
						<option>Will</option>
					</select>
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Defenses</span>
					</div>
					<input class="form-control" v-model="defenses">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Resistances</span>
					</div>
					<input class="form-control" v-model="resistances">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Weaknesses</span>
					</div>
					<input class="form-control" v-model="weaknesses">
				</div>
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 7em;">Speed</span>
					</div>
					<input class="form-control" v-model="speed">
				</div>
			</div>

			<div class="col-12 col-sm-3">
				<label>Attacks</label>
				<div class="card">
					<div class="list-group list-group-flush">
						<div class="list-group-item" v-for="(attack, attackID) in attacks" :key="`companion-attacks-${level}-${attackID}`">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Name</span>
								</div>
								<input class="form-control" v-model="attack.Name">
							</div>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Type</span>
								</div>
								<input class="form-control" v-model="attack.Damage">
								<select class="form-control" v-model="attack.Type">
									<option>Melee</option>
									<option>Ranged</option>
								</select>
							</div>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Critical</span>
								</div>
								<input class="form-control" v-model="attack.Critical">
							</div>
							<button class="btn btn-block btn-danger" @click="removeCompanionAttack(level, attackID)" v-if="Character.Levels[level].Companion.Attacks.length > 1">Remove Attack</button>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-block btn-default" @click="addCompanionAttack(level)"><i class="fas fa-plus"></i> Add Attack</button>
					</div>
				</div>
			</div>

			<div class="col-12 col-sm-3">
				<label>Ability Mods</label>
				<small class="text-muted">Higher, Lower</small>
				<div class="input-group" v-for="(mod, ability) in abililtyMods" :key="`companion-abilityMods-${level}-${ability}`">
					<div class="input-group-prepend">
						<span class="input-group-text" style="width: 3.5em;">{{ability|abbr}}</span>
						<div class="input-group-text">
							<input type="radio" v-model="abilityBest" :value="ability">
						</div>
						<div class="input-group-text">
							<input type="radio" v-model="abilityBetter" :value="ability">
						</div>
					</div>
					<input type="number" class="form-control" v-model="abililtyMods[ability]" />
				</div>
			</div>

			<div class="col-12 col-sm-3">
				<label>Special Abililties</label>
				<div class="card">
					<div class="list-group list-group-flush">
						<div class="list-group-item" v-for="(special, specialID) in specials" :key="`companion-specials-${level}-${specialID}`">
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Name</span>
								</div>
								<input class="form-control" v-model="special.Name">
							</div>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Type</span>
								</div>
								<select class="form-control" v-model="special.Type">
									<option value=""></option>
									<option value="Ex">Extrordinary</option>
									<option value="Su">Supernatural</option>
									<option value="Special">Spell-Like</option>
								</select>
							</div>
							<div class="input-group">
								<div class="input-group-prepend">
									<span class="input-group-text">Desc</span>
								</div>
								<textarea class="form-control" v-model="special.Description"></textarea>
							</div>
							<button class="btn btn-block btn-danger" @click="removeCompanionSpecial(level, attackID)">Remove Special Abililty</button>
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-block btn-default" @click="addCompanionSpecial(level)"><i class="fas fa-plus"></i> Add Special Ability</button>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import ucFirst from "@/mixins/ucfirst.js";

function mapCompanionProperties( properties ){
	var computed = {}
	properties.forEach((property) => {
		computed[property] = {
			get () {
				return this.$store.getters[`character/companions/${property}`](this.level)
			},
			set ( value ){
				this.$store.dispatch(`character/companions/update${this.ucFirst(property)}`,{
					level: this.level,
					value,
				})
			}
		}
	})
	return computed
}

export default {
	mixins: [
		ucFirst,
	],
	props: [
		'level',
	],
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		AbilityMods: function() {
			return this.$store.getters['character/companions/abilityMods'](this.level)
		},
		...mapCompanionProperties([
			'name',
			'cLevel',
			'size',
			'type',
			'speed',
			'senses',
			'save',
			'abililtyMods',
			'abilityBest',
			'abilityBetter',
			'defenses',
			'resistances',
			'weaknesses',
			'specialAbilities',
		])
	}
}
</script>

<style scoped>

</style>